import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { NoteArticleSelectTableModel } from 'src/app/models/invoicing/note-article-select-table.model';
import { NoteDetailModel } from 'src/app/models/invoicing/note-detail.model';
import { NoteModel } from 'src/app/models/invoicing/note.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { NoteDetailService } from 'src/app/services/invoicing/note-detail.service';
import { NoteService } from 'src/app/services/invoicing/note.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-note-detail-article',
  templateUrl: './register-note-detail-article.component.html',
  styleUrls: ['./register-note-detail-article.component.scss'],
  standalone: false,
})

export class RegisterNoteDetailArticleComponent implements OnInit {

  @Input() isDocumentSupport: boolean = false;
  @Input() noteModel: NoteModel = new NoteModel();
  @Input() noteDetailContract: NoteDetailModel = new NoteDetailModel();
  @Output() noteContract = new EventEmitter<NoteModel>();
  @Output() newNoteDetail = new EventEmitter<NoteDetailModel>();
  @Output() updateListDetail = new EventEmitter<boolean>();
  @Output() isFormView = new EventEmitter<boolean>();

  articleId: number | null = 0;
  codeNameArticle: string = '';
  conceptInvoicingId: number = 0;
  formNoteDetail: FormGroup = new FormGroup({});
  listConceptInvoicing: any[] = [];
  listStore: any[] = [];
  newArticlesDetail: number = 0;
  noteDetailId: number = 0;
  noteId: number = 0;
  storeId: number = 0;

  component = CustomTableSelectComponent;
  inputsForArticlesSelect$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: false,
    filters: [],
    actions: [],
  })
  output$ = new Subject<any>();

  dataArticle: PagedResponseModel<NoteArticleSelectTableModel> = new PagedResponseModel<NoteArticleSelectTableModel>();
  headerArticle: ColumnResponseModel[] = [];
  ascendantArticle: boolean = true;
  columnSortArticle: string | null = null;
  filtersArticle: ColumnResponseModel[] = []
  limitArticle: number = 5;
  pageArticle: number = 1;
  subscription: Subscription;
  @ViewChild('selectArticle') articleModalComponent?: CustomModalComponent | null = null;

  constructor(private formBuilder: FormBuilder,
    private noteService: NoteService,
    private noteDetailService: NoteDetailService,
    private toastHandlerService: ToastHandlerService,) {
    this.validateForm(this.noteDetailContract);
  }

  async ngOnInit(): Promise<void> {
    await this.getColumnsArticle();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    const noteModel = changes["noteModel"];
    if (noteModel) {
      if (this.noteModel.noteId != 0) {
        await Promise.all([
          this.getConceptInvoicingList(),
          this.getStoresList()
        ]);
      }
    }
    const noteDetailContract = changes["noteDetailContract"];
    if (noteDetailContract) {
      if (this.noteDetailContract.noteDetailId == 0) {
        this.createNewNoteDetail();
      } else {
        this.updateListDetail.emit(true);
        this.noteDetailId = this.noteDetailContract.noteDetailId;
        await this.validateForm(this.noteDetailContract);
      }
      this.calculateTotalValue();
      setTimeout(() => this.formNoteDetail.controls["totalValue"].disable(), 100);
    }
  }

  calculateTotalValue() {
    const totalTime = this.formNoteDetail.get("totalTime")?.value ?? 1;
    const unitValue = this.formNoteDetail.get("unitValue")?.value;
    const quantity = this.formNoteDetail.get("quantity")?.value;

    //Calculo el vr total
    const totalValue = (quantity * totalTime * unitValue)
    this.formNoteDetail.controls["totalValue"].setValue(totalValue);
  }

  clearForm(closeForm: boolean) {
    const modelNoteDetail = new NoteDetailModel;
    this.storeId = 0;
    this.articleId = 0;
    this.conceptInvoicingId = 0;
    this.codeNameArticle = '';
    this.newNoteDetail.emit(modelNoteDetail);
    this.isFormView.emit(closeForm);
  }

  createNewNoteDetail() {
    this.noteDetailId = 0;
    this.noteDetailContract.totalTime = 1;
    this.codeNameArticle = '';
    this.validateForm(this.noteDetailContract);
  }

  changeQuantity() {
    const quantity = this.formNoteDetail.get("quantity")?.value;
    if (quantity < 0 || !quantity) {
      this.toastHandlerService.showToast(
        'warning',
        'La cantidad a facturar es menor o igual a cero.'
      );
      return;
    }
    this.calculateTotalValue();
  }

  async getConceptInvoicingList(): Promise<void> {
    try {
      if (this.noteModel.invoiceId !== null)
        this.listConceptInvoicing = await firstValueFrom(this.noteDetailService.getAllConceptInvoicingForSelectAsync(this.noteModel.invoiceId));
    } catch (error) {
      console.error('Error al obtener la lista de conceptos de facturación:', error);
    }
  }

  async getStoresList(): Promise<void> {
    if (this.noteModel.invoiceId !== null && this.conceptInvoicingId !== 0) {
      try {
        this.listStore = await firstValueFrom(this.noteDetailService.getAllStoreForSelectAsync(this.noteModel.invoiceId, this.conceptInvoicingId));
      } catch (error) {
        console.error('Error al cargar lista de bodegas:', error);
      }
    }
  }

  async getArticle(articleId: number | null, reload: boolean) {
    if (articleId != null && articleId != 0) {
      const article = await firstValueFrom(this.noteDetailService.getArticleById(articleId));
      if (article) {
        if (this.conceptInvoicingId == null && !this.isDocumentSupport ||
          this.conceptInvoicingId == 0 && !this.isDocumentSupport) {
          this.toastHandlerService.showToast(
            'warning',
            'Debe seleccionar el concepto de facturación.'
          );
          return;
        }
        this.codeNameArticle = article.codeName;
        this.formNoteDetail.controls['articleId'].patchValue(articleId);
        this.articleId = articleId;
      } else {
        this.articleId = 0;
        this.codeNameArticle = "Error al buscar el elemento. Por favor refresque la página.";
        return;
      }
      if (reload) this.getNoteDetailByKeys();
    } else {
      this.articleId = 0;
      this.codeNameArticle = '';
    }
  }

  async getAllArticlesForSelect() {
    try {
      this.dataArticle = await firstValueFrom(
        this.noteDetailService.getArticlesForNote(this.noteModel.noteId, this.conceptInvoicingId, this.storeId, this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle)
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de articulos.', error);
    }
  }

  async getColumnsArticle() {
    try {
      if (this.headerArticle.length === 0) {
        this.headerArticle = await firstValueFrom(this.noteDetailService.GetColumnsForArticleCaptureNote());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getConceptInvoicing(conceptInvoicingId: number | null, reload: boolean) {
    if (conceptInvoicingId != null && conceptInvoicingId != 0) {
      const conceptInvoicing = this.listConceptInvoicing.find(x => x.value == conceptInvoicingId);
      if (conceptInvoicing) {
        this.conceptInvoicingId = conceptInvoicingId;
        await this.getStoresList();
      } else {
        this.conceptInvoicingId = 0;
        return;
      }
    } else {
      this.conceptInvoicingId = 0;
    }
    if (reload) {
      const modelNoteDetail = new NoteDetailModel;
      modelNoteDetail.conceptInvoicingId = this.conceptInvoicingId;
      modelNoteDetail.storeId = 0;
      modelNoteDetail.articleId = 0;
      this.storeId = 0;
      this.articleId = 0;
      this.codeNameArticle = '';
      this.newNoteDetail.emit(modelNoteDetail);
    }
  }

  async getNoteById(noteById: number) {
    try {
      this.noteContract.emit(await firstValueFrom(this.noteService.getNoteById(noteById)));
    } catch (error) {
      console.error('Error al buscar la nota por id.', error);
    }
  }

  async getNoteDetailByKeys() {
    if (this.conceptInvoicingId != 0 && this.storeId != 0) {
      try {
        const response = await firstValueFrom(this.noteDetailService.getNoteDetailByKeys(this.noteModel.noteId, this.conceptInvoicingId, this.storeId,
          this.articleId));
        this.newNoteDetail.emit(response);
      } catch (error) {
        console.error('Error al consultar el detalle por claves.', error);
        const modelNoteDetail = new NoteDetailModel;
        modelNoteDetail.conceptInvoicingId = this.conceptInvoicingId;
        modelNoteDetail.storeId = this.storeId;
        this.newNoteDetail.emit(modelNoteDetail);
      }
    }
    if (this.conceptInvoicingId == 0 && this.storeId == 0) {
      try {
        const response = await firstValueFrom(this.noteDetailService.getNoteDetailByKeys(this.noteModel.noteId, this.conceptInvoicingId, this.storeId,
          this.articleId));
        this.newNoteDetail.emit(response);
      } catch (error) {
        console.error('Error al consultar el detalle por claves.', error);
        const modelNoteDetail = new NoteDetailModel;
        modelNoteDetail.conceptInvoicingId = 0;
        modelNoteDetail.storeId = 0;
        this.newNoteDetail.emit(modelNoteDetail);
      }
    }
  }

  async getStore(storeId: number | null, reload: boolean) {
    if (storeId != null && storeId !== 0) {
      const store = this.listStore.find(x => x.value == storeId);
      if (!store) {
        this.storeId = 0;
        this.formNoteDetail.controls["storeId"].patchValue(0);
        return;
      }
      this.storeId = storeId;
      this.formNoteDetail.controls["storeId"].patchValue(storeId);
    } else {
      this.storeId = 0;
      this.formNoteDetail.controls["storeId"].patchValue(0);
      if (reload) {
        const modelNoteDetail = new NoteDetailModel();
        modelNoteDetail.conceptInvoicingId = this.conceptInvoicingId;
        modelNoteDetail.storeId = 0;
        this.newNoteDetail.emit(modelNoteDetail);
      }
    }
  }

  async handleSelectedItems(selectedItems: any) {
    this.newArticlesDetail = parseInt(selectedItems[0].articleId);
    this.getArticle(this.newArticlesDetail, false);
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    this.getAllArticlesForSelect();
  }

  async openArticleModal() {
    const conceptInvoicing = this.formNoteDetail.get("conceptInvoicingId")?.value;
    const store = this.formNoteDetail.get("storeId")?.value;
    if ((!conceptInvoicing && !store) && !this.isDocumentSupport) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe seleccionar una bodega.'
      );
    } else {
      this.filtersArticle = [];
      await Promise.all([
        this.getColumnsArticle(),
        this.getAllArticlesForSelect()
      ]);
      this.updateInputs();
      this.articleModalComponent && this.articleModalComponent.show();
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send() {
    if (this.isDocumentSupport && this.formNoteDetail.controls["conceptInvoicingId"].value == null) {
      this.formNoteDetail.controls["conceptInvoicingId"].setValue(0);
      this.formNoteDetail.controls["totalTime"].setValue(1);
    }
    //Asigno la clave de la Nota
    this.formNoteDetail.controls["noteId"].setValue(this.noteModel.noteId);
    if (this.formNoteDetail.valid) {
      const modelNoteDetail = this.formNoteDetail.value as NoteDetailModel;
      if (this.noteDetailId == 0) {
        try {
          const response = await firstValueFrom(this.noteDetailService.createNoteDetail(modelNoteDetail));
          this.toastHandlerService.showToast(
            'success',
            'El detalle de la nota fue creado exitosamente.'
          );
          this.getNoteById(response.noteId);
          this.noteDetailContract = new NoteDetailModel();
          this.clearForm(false)
          this.updateListDetail.emit(true);
        } catch (error) {
          console.error('Error al crear la nota.', error);
        }
      } else {
        this.noteDetailContract.document = modelNoteDetail.document;
        this.noteDetailContract.totalTime = modelNoteDetail.totalTime;
        this.noteDetailContract.unitValue = modelNoteDetail.unitValue;
        this.noteDetailContract.quantity = modelNoteDetail.quantity;
        this.noteDetailContract.totalValue = modelNoteDetail.totalValue;
        this.noteDetailContract.accountingCostCenter = modelNoteDetail.accountingCostCenter;
        try {
          const response = await firstValueFrom(this.noteDetailService.updateNoteDetail(this.noteDetailContract));
          this.toastHandlerService.showToast(
            'success',
            'El detalle de la nota fue modificado exitosamente.'
          );
          this.getNoteById(response.noteId);
          this.noteDetailContract = new NoteDetailModel();
          this.clearForm(false)
          this.updateListDetail.emit(true);
        } catch (error) {
          this.updateListDetail.emit(true);
          console.error('Error al actualizar el detalle de la nota.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  public showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      conceptInvoicingId: {
        required: 'El campo "Concepto facturación" es obligatorio.'
      },
      storeId: {
        required: 'El campo "Bodega" es obligatorio.'
      },
      articleId: {
        required: 'El campo "Artículo" es obligatorio.',
        min: 'El campo "Artículo" es obligatorio.'
      },
      document: {
        maxlength: 'El campo "Documento" no puede exceder los 10 caracteres.'
      },
      totalTime: {
        required: 'El campo "Días" es obligatorio.',
        min: 'El campo "Días" debe ser mayor a 0.'
      },
      unitValue: {
        required: 'El campo "Vr. Unitario" es obligatorio.',
        min: 'El campo "Vr. Unitario" debe ser mayor a 0.'
      },
      quantity: {
        required: 'El campo "Cantidad" es obligatorio.',
        min: 'El campo "Cantidad" debe ser mayor a 0.'
      },
      totalValue: {
        required: 'El campo "Vr. Total" es obligatorio.',
        min: 'El campo "Vr. Total" debe ser mayor a 0.'
      },
      accountingCostCenter: {
        maxlength: 'El campo "C. Costo Contable" no puede exceder los 50 caracteres.'
      }
    };

    const form = this.formNoteDetail;
    Object.keys(controlMessages).forEach((controlName: string) => {
      const control = form.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach((errorKey: string) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateInputs() {
    this.inputsForArticlesSelect$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }

  async validateForm(noteDetailModel: NoteDetailModel) {
    this.formNoteDetail = this.formBuilder.group({
      noteId: [noteDetailModel.noteId, [Validators.required, Validators.min(1)]],
      conceptInvoicingId: [noteDetailModel.conceptInvoicingId],
      storeId: [noteDetailModel.storeId],
      articleId: [noteDetailModel.articleId, [Validators.required, Validators.min(1)]],
      document: [noteDetailModel.document, [Validators.maxLength(10)]],
      totalTime: [noteDetailModel.totalTime, [Validators.required, Validators.min(1)]],
      unitValue: [noteDetailModel.unitValue, [Validators.required, Validators.min(1)]],
      quantity: [noteDetailModel.quantity, [Validators.required, Validators.min(1)]],
      totalValue: [noteDetailModel.totalValue, [Validators.required, Validators.min(1)]],
      accountingCostCenter: [noteDetailModel.accountingCostCenter, [Validators.maxLength(50)]],
    });
    this.articleId = noteDetailModel.articleId;
    this.storeId = noteDetailModel.storeId ?? 0;
    this.conceptInvoicingId = noteDetailModel.conceptInvoicingId ?? 0;
    setTimeout(() => this.formNoteDetail.controls["accountingCostCenter"].disable());
    if (noteDetailModel.noteDetailId != 0) {
      await this.getConceptInvoicing(this.noteDetailContract.conceptInvoicingId, false);
      await this.getStore(this.noteDetailContract.storeId, false);
      await this.getArticle(this.noteDetailContract.articleId, false);
      this.formNoteDetail.controls["conceptInvoicingId"].disable();
      this.formNoteDetail.controls["storeId"].disable();
    }
  }
}

